import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomersIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 6.26242H3.55556C2.69645 6.26242 2 6.97612 2 7.85651V15.827C2 16.7073 2.69645 17.421 3.55556 17.421H16C16.8591 17.421 17.5556 16.7073 17.5556 15.827V7.85651C17.5556 6.97612 16.8591 6.26242 16 6.26242Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.8888 17.4211V4.6684C12.8888 4.24562 12.725 3.84016 12.4332 3.54121C12.1415 3.24226 11.7459 3.07431 11.3333 3.07431H8.22218C7.80962 3.07431 7.41396 3.24226 7.12224 3.54121C6.83051 3.84016 6.66663 4.24562 6.66663 4.6684V17.4211",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCustomersIcon;
